<template>
  <DBox
    :id="'settings-accounting-tax_types_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('tax_type')}`"
    @add_click="onAddTaxTypeClick"
  >
    <div class="cmp-settings-accounting-tax_types_list">
      <NTable
        :id="'settings-accounting-tax_types_list'"
        class="h1 dbox1"
        :headers="headers"
        :items="tax_types"
        :config="tableConfig"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr draggable="true" @dragstart="e => onTaxTypeDragstart(e, item)">
            <td v-bind="tdcon('tax_name')" :title="item['tax_name']">
              <span class="txtov">{{ item.tax_name }}</span>
            </td>
            <td
              v-bind="tdcon('tax_description')"
              :title="descriptionText(item)"
            >
              <span class="txtov">{{ item.tax_description }}</span>
            </td>
            <td v-bind="tdcon('tax_rate')">
              <span>{{ item.tax_rate_percent }} %</span>
            </td>
            <td v-bind="tdcon('tax_deduction_text')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="`tax_deduction_flag=${item.tax_type_id}`"
                    :id="`tax_deduction_flag=${item.tax_type_id}`"
                    :checked="item.tax_deduction_flag == 1"
                    @click="
                      e =>
                        onTaxDeductionFlagChange(e, 'tax_deduction_flag', item)
                    "
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <div class="hormid">
                <div class="dt-icon-container">
                  <img
                    src="static/icons/edit-blue.svg"
                    class="dt-icon v5 s1 ut-center"
                    @click="e => onTaxTypeEdit(item)"
                    :alt="$t('edit_tax_type')"
                    :title="$t('edit_tax_type')"
                  />
                </div>
                <div class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    class="dt-icon v5 s1 ut-center"
                    @click="e => onDeleteTaxType(item)"
                    :alt="$t('delete_custom_field')"
                    :title="$t('delete_custom_field')"
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";

export default {
  components: {
    NTable,
    DBox
  },
  props: {
    accountingSettingsData: {
      type: Object,
      default: () => []
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true,
        footer: false
      })
    };
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("tax_name", { text: 'tax_types' }),
        createTableHeader("tax_description", {
          text: 'tax_description',
          f: 1.6
        }),
        createTableHeader("tax_rate", { f: 0.7 }),
        createTableHeader("tax_deduction_text", { mw: 130, ta: "center" }),
        createTableHeader("options", { text: false, mw: 70 })
      ];
    },
    tax_types: function() {
      return this.accountingSettingsData?.tax_types || [];
    }
  },
  methods: {
    onAddTaxTypeClick: function() {
      this.$emit("add_click", true);
    },
    onDeleteTaxType: function(item) {
      this.$emit("delete_click", item);
    },
    onTaxTypeEdit: function(item) {
      this.$emit("edit_click", item);
    },
    onTaxTypeDragstart: function(event, item) {
      if (!item) {
        return;
      }
      event.dataTransfer.setData("text", JSON.stringify(item));
    },
    onTaxDeductionFlagChange: function(event, name, item) {
      const value = event.target.checked ? "1" : "0";
      this.$emit("changed", { name, value, item });
    },
    descriptionText(item) {
      return `${item["tax_description"]}`;
    }
    // MARK: Methods
  }
};
</script>
